export default {
  h1: {
    fontWeight: 500,
    fontSize: '3rem',
    letterSpacing: '-0.24px'
  },
  h2: {
    fontWeight: 500,
    fontSize: '2rem',
    letterSpacing: '-0.24px'
  },
  h3: {
    fontWeight: 500,
    fontSize: '1.8rem',
    letterSpacing: '-0.06px'
  },
  h4: {
    fontWeight: 500,
    fontSize: '1.5rem',
    letterSpacing: '-0.06px'
  },
  h5: {
    fontWeight: 500,
    fontSize: '1.2rem',
    letterSpacing: '-0.05px'
  },
  h6: {
    fontWeight: 500,
    fontSize: '1.15rem',
    letterSpacing: '-0.05px'
  },
  overline: {
    fontWeight: 500
  }
};
